import { Bike, Footprints, Package, UtensilsCrossed } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { DiningCaps } from '@/features/discovery/types';

const KIND_LABEL: Record<DiningCaps['kind'], string> = {
  PET_CAFE: 'Café',
  PET_RESTAURANT: 'Restaurant',
  PET_BAKERY: 'Bakery',
};

export const dining_kind_label = (k: DiningCaps['kind']) => KIND_LABEL[k] ?? k;

/** Compact capability chips for discovery cards + the vendor detail header. */
export function DiningChips({ dining, className }: { dining: DiningCaps; className?: string }) {
  const chips: { icon: LucideIcon; label: string }[] = [];
  if (dining.dine_in) chips.push({ icon: UtensilsCrossed, label: 'Dine-in' });
  if (dining.walk_in) chips.push({ icon: Footprints, label: 'Walk-ins welcome' });
  if (dining.delivery) chips.push({ icon: Bike, label: 'Delivers' });
  if (dining.pickup) chips.push({ icon: Package, label: 'Pickup' });
  if (chips.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {chips.map((c) => (
        <span
          key={c.label}
          className="inline-flex items-center gap-1 rounded-full bg-secondary px-2.5 py-0.5 text-xs font-semibold text-secondary-foreground"
        >
          <c.icon className="h-3 w-3" /> {c.label}
        </span>
      ))}
    </div>
  );
}
